// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"18":"results","784":"stats","908":"history"}[chunkId] + "." + {"18":"72f2c415","784":"ab6508dd","908":"b09761b5"}[chunkId] + ".js";
};